const e=["staging","development",void 0],o=["fi-fi"],n=({environment:n,locale:i})=>e.includes(n?.toLowerCase())||o.includes(i.toLowerCase());export{n as canTurnOnV2};
//# sourceMappingURL=canTurnOnV2.js.map
